import * as React from 'react';

import { OfficeGeneralPartView } from './officegeneral-part.view';
import { CardController } from 'src/app/shared/card.controller';

interface OfficeGeneralPartControllerProps extends ComponentViewProps<TransportCompanyOfficeItem> {
	mode: ControlMode;
}

export class OfficeGeneralPartController extends React.Component<OfficeGeneralPartControllerProps, {}> {
	constructor(props) {
		super(props);
	}

	render() {
		const office = this.props.model;
		if (office == null) {
			return null;
		}

		return (
			<CardController
				icon="book"
				className="card-borderless"
				title="Office Information"
				mode={this.props.mode}>
				<OfficeGeneralPartView
					mode={this.props.mode}
					model={office}
					setBusy={this.props.setBusy}
				/>
			</CardController>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/products/office/parts/officegeneral-part.controller.tsx